import { render, staticRenderFns } from "./HierarchyViewColumnHeadingAlt.vue?vue&type=template&id=77018659&scoped=true"
import script from "./HierarchyViewColumnHeadingAlt.vue?vue&type=script&lang=js"
export * from "./HierarchyViewColumnHeadingAlt.vue?vue&type=script&lang=js"
import style0 from "./HierarchyViewColumnHeadingAlt.vue?vue&type=style&index=0&id=77018659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77018659",
  null
  
)

export default component.exports